import React, {Component} from 'react';
import App from "../../App";
import { Link, withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import PromotionForm from "./CreateForm";
import { MdArrowBack } from "react-icons/all";
import moment from 'moment';
import { postData } from '../../services/baseServices'

class Add extends Component {
  state = {
    formData: {
      is_active: 1,
      is_time_bound: 0,
      start_time: moment(new Date()).format("HH:mm"),
      end_time: moment(new Date()).format("HH:mm"),
    },
    conf_fields: [],
    fields: [],
    errors:{
      from_date: '',
      to_date: '',
      days: ''
    }
  };

  handleFieldsConfiguration = (fields) => {
    this.setState({conf_fields: fields})
  }

  handleInputOnChange = (e) => {
    const formData = {...this.state.formData};
    if(e.target.type === "checkbox") {
      formData[e.target.name] = e.target.checked?1:0;
    }
    // else if(e.target.name==='email' && e.target.value.match(e.target.pattern) === null){
    //   this.setState({errors: {...this.state.errors, email: 'Please provide valid email'}});
    //   return;
    // }else if(e.target.name==='phone' && e.target.value.match(e.target.pattern) === null){
    //   this.setState({errors: {...this.state.errors, phone: 'Please provide valid BD phone number'}});
    //   return;
    // }else if(e.target.name==='password' && e.target.value.match(e.target.pattern) === null){
    //   this.setState({errors: {...this.state.errors, password: 'At least one number and one uppercase and lowercase letter, and more than 8 characters'}});
    //   return;
    // }else if(e.target.name==='password_confirmation' && formData["password"]!==e.target.value){
    //   this.setState({errors: {...this.state.errors, password_confirmation: 'Password doesn\'t match'}});
    //   return;
    // }
    else {
      formData[e.target.name] = e.target.value;

    }
    this.setState({formData}, () => { });
  }

  onPromoFieldChange = (name, value) => {
    let fieldsArray = this.state.fields.filter(item => item.name !== name)
    let fieldObject =
      {
        name: name,
        value: value
      };
    fieldsArray.push(fieldObject);
    this.setState({fields: fieldsArray},() => {
      if(this.state.isFormValidated) {
        this.isValidFields()
      }
    })
  }

  checkDateValidation = (key) => {
    const formData = {...this.state.formData};
    let err = {...this.state.errors}
    if(!formData[key]){
      console.log(key)
      err[key] = key+' is required';
    } else {
      console.log(key)
      err[key] = '';
    }

    this.setState({errors: err});
  }

  handleTimeOnChange = (key, time) => {
    const formData = {...this.state.formData};
    formData[key] = time;
    this.setState({formData}, () => {
      //this.checkDateValidation(key);
    });
  }

  handleDateOnChange = (key ,date) => {
    const formData = {...this.state.formData};
    formData[key] = moment(date).format("YYYY-MM-DD");
    this.setState({formData}, () => {
      this.checkDateValidation(key);
    });
  }

  handleDayChange = (weekDays) => {
    const formData = {...this.state.formData};
    let days = 
      weekDays.filter(item => item.selected).map(item=> {
        return item.day_value
      })
    formData.days = days;
    this.setState({formData}, () => {
      console.log(formData)
    });
    if(this.state.isFormValidated && this.state.formData.is_time_bound && (!this.state.formData.days || this.state.formData.days?.length <= 0)) {
      this.setState({errors: {...this.state.errors, days: ''}});
    }
  }

  isValidFields = () => {
    let validFields = []
    let err = {...this.state.errors}

    this.state.conf_fields.map(con_field => {
      let field = this.state.fields.find(field => field.name == con_field.name)
      if(!field || !field.value || field.value.length < 0) {
        err[con_field.name] = con_field.title+' is required';
        validFields.push(false)
      }
      else {
        err[con_field.name] = '';
        validFields.push(true)
      }
    })
    this.setState({errors: err});
    let isInvalid = validFields.includes(false)
    
    return !isInvalid
  }

  isValid = () => {
    let valid = true;
    let err = {...this.state.errors}

    if(!this.state.formData.from_date) {
      valid = false
      err["from_date"] = 'From date is required';
    }
    if(!this.state.formData.to_date) {
      valid = false
      err["to_date"] = 'To date is required';
      //this.setState({errors: {...this.state.errors, to_date: 'To date is required'}});
    } 
    if(this.state.formData.is_time_bound && (!this.state.formData.days || this.state.formData.days?.length <= 0)) {
      valid = false
      err["days"] = 'Day(s) are required';
      //this.setState({errors: {...this.state.errors, days: 'Day(s) are required'}});
    }
    this.setState({errors: err});
    
    return valid && this.isValidFields();
  }

  handleAddPromo = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      form.className += " was-validated";
      this.setState({isFormValidated: true})
      if(!this.isValid()) {
        toast.error("Please fill all(*) required fields")
        this.setState({isSubmitting: false})
      }
    } else {
      this.setState({isSubmitting: true}, () => {
        this.setState({isFormValidated: true})
        if(!this.isValid()) {
          toast.error("Please fill all(*) required fields")
          this.setState({isSubmitting: false})
          return
        }
        const formData = {...this.state.formData};
        let promoType = formData.promotion_rule;
        delete formData.promotion_rule;
        let promoModel =
          {
            promotion: formData
          }
        let promotion_rule =
          {
            rule: promoType,
            fields: this.state.fields
          }
          promoModel = Object.assign({
            promotion: {
              ...formData,
              promotion_rule
            }
          })
        console.log(promoModel)
        postData("promotions", promoModel)
          .then(res => {
            if(res.id) {
              this.props.history.push(`/promotions/list`);
              toast.success("Promotion has been created successfully.");
            }
            else{
              toast.error(res.message);
              this.setState({isSubmitting: false})
            }
          })
          .catch(errMsg => {
            toast.error(errMsg);
            this.setState({isSubmitting: false})
          });
      })
    }
  }

  render() {

    return (
      <App layout="boxed">
        <div className="page-header">
          <h2 className="page-title">Add Promotion</h2>
          <div className="ml-auto">
            <Link to={`${process.env.PUBLIC_URL}/promotions/list`} className={`btn btn-sm btn-link`}><MdArrowBack/>
              Back to List
            </Link>
          </div>
        </div>

        <div className="card-block">
          <div className="block-body">
              <>
                <PromotionForm
                  handleClick={this.handleAddPromo}
                  handleInputOnChange={this.handleInputOnChange}
                  handleDateOnChange={this.handleDateOnChange}
                  handleTimeOnChange={this.handleTimeOnChange}
                  handleDayChange={this.handleDayChange}
                  onPromoFieldChange={this.onPromoFieldChange}
                  handleFieldsConfiguration={this.handleFieldsConfiguration}
                  formData={this.state.formData}
                  isSubmitting={this.state.isSubmitting}
                  isFormValidated={this.state.isFormValidated}
                  errors={this.state.errors}
                />
              </>
          </div>
        </div>
      </App>
    );
  }
}
export default withRouter(Add);